module.exports = __webpack_public_path__ + "img/facebook.b3e1260a.png";